import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { ContactShortDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  query: string;
};

type Return = {
  getContactsShort: (req: Req) => Promise<ContactShortDto[]>;
  isGettingContactsShort: boolean;
};

export const useGetContactsShort = (): Return => {
  const { contactsApi } = useApiClient();
  const { userId } = useUserContext();

  const { isPending, mutateAsync } = useMutation<ContactShortDto[], AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const res = await contactsApi.getShortContacts(req.query, userId);
      return res.data;
    },
    mutationKey: [QueryKeyEnum.CONTACTS.SHORT],
  });

  return {
    getContactsShort: mutateAsync,
    isGettingContactsShort: isPending,
  };
};
